<div class="form" *appMailAppContext>
  <div class="form-date">{{ message?.date | dateFormat : 'date' }}</div>

  <h2 class="form-title">
    {{ message?.title }}
  </h2>

  @if (message) {
    <app-shared-tags
      class="form-tags"
      [stitchItem]="message"
      [stateKey]="StateKey.tagsList"
    />

    <app-shared-knots
      class="form-knots"
      [stitchItem]="message"
      [stateKey]="StateKey.knotsList"
    />
  }

  <app-shared-signup-cta />

  @if (message?.bodyHtml) {
    <!-- The mail is in a frame of its own: its knot highlights are painted there, from [highlights]. -->
    <stch-mail-body [body]="message?.bodyHtml"
                    [message]="message"
                    [highlights]="highlights()"
                    [showBlockingExternalImagesBanner]="false"/>
  }

  @if (message?.folderId) {
    <div class="form-details">
      <div class="form-details-row">
        <div class="form-details-row-title">Folder</div>
        <div class="form-details-row-input">{{ message?.folderId }}</div>
      </div>
    </div>
  }
</div>
